module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-6.05bddaf2.png";